import {
  GET_TENDER_MENUS,
  DELETE_TENDER_MENU,
  ERROR_DATA,
  SAVE_TENDER_MENU,
  UPDATE_TENDER_MENU,
  SYNCING,
  TENDER_MENU_LOADED,
  RESET_TENDER_MENU,
} from './actionTypes';
import {
  IDeleteTenderMenusAction,
  ISetTenderMenuAction,
  ISetTenderMenusAction,
  ISetTenderMenusErrorAction,
  ITenderMenuAction,
  ITenderMenuItem,
  ITenderMenusState,
} from './types';

export const initialState: ITenderMenusState = {
  error: null,
  tenderMenus: [],
  syncing: false,
  tenderMenu: null,
};

export const reducer = (
  state: ITenderMenusState = initialState,
  action: ITenderMenuAction
): ITenderMenusState => {
  let tenderMenus: ITenderMenuItem[] = [];
  switch (action.type) {
    case GET_TENDER_MENUS:
      return {
        ...state,
        syncing: false,
        error: null,
        tenderMenus: (action as ISetTenderMenusAction).payload,
      };
    case ERROR_DATA:
      return {
        ...state,
        error: (action as ISetTenderMenusErrorAction).payload,
        tenderMenus: [],
        syncing: false,
      };
    case DELETE_TENDER_MENU:
      tenderMenus = state.tenderMenus.filter(
        (menu) => menu.id !== (action as IDeleteTenderMenusAction).payload
      );
      return { ...state, error: null, tenderMenus };
    case UPDATE_TENDER_MENU:
      const act = action as ISetTenderMenuAction;
      const tenderMenuId = act.payload.id;
      const updatedTenderMenus = state.tenderMenus.map((item) => {
        if (item.id === tenderMenuId) {
          return act.payload;
        }
        return item;
      });
      return {
        ...state,
        error: null,
        tenderMenus: updatedTenderMenus,
        syncing: false,
        tenderMenu: act.payload,
      };
    case SAVE_TENDER_MENU:
      const newTenderMenus = state.tenderMenus.filter(() => true);
      newTenderMenus.push((action as ISetTenderMenuAction).payload);
      return { ...state, error: null, tenderMenus: newTenderMenus, syncing: false };
    case TENDER_MENU_LOADED:
      return { ...state, syncing: false, tenderMenu: (action as ISetTenderMenuAction).payload };
    case RESET_TENDER_MENU:
      return { ...state, syncing: false, tenderMenu: null };
    case SYNCING:
      return { ...state, syncing: true };

    default:
      return state;
  }
};
